import {
    GET_DATA_ADMIN_DASHBOARD_SUCCESS,
    GET_DATA_ADMIN_DASHBOARD_FAILURE
} from './action'

const initialState = {
    adminDashBoardSuccessData: null,
    adminDashBoardFailureData: null
}

const adminDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DATA_ADMIN_DASHBOARD_SUCCESS:
            return state = {
                ...state,
                adminDashBoardSuccessData: action.data
            }
        case GET_DATA_ADMIN_DASHBOARD_FAILURE:
            return state = {
                ...state,
                adminDashBoardFailureData: action.data
            }
        default:
            return state
    }
}

export default adminDashboardReducer;